export default "__VITE_ASSET__BU$Sz4Gh__"